/* eslint-disable */     
import { ProductService } from '@/store/product/product-service';
import Message from '@/shared/message/toastify';
import Errors from '@/shared/error/errors';
import { i18n } from '@/locales/i18n';
// import { routerAsync } from '@/app-module';
import router from '@/router'

export default {
  namespaced: true,

  state: {
    findLoading: false,
    saveLoading: false,
    record: null,
  },

  getters: {
    record: (state) => state.record,
    findLoading: (state) => !!state.findLoading,
    saveLoading: (state) => !!state.saveLoading,
  },

  mutations: {
    RESET(state) {
      state.findLoading = false;
      state.saveLoading = false;
      state.record = null;
    },

    FIND_STARTED(state) {
      state.record = null;
      state.findLoading = true;
    },
    FIND_SUCCESS(state, payload) {
      state.record = payload;
      state.findLoading = false;
    },
    FIND_ERROR(state) {
      state.record = null;
      state.findLoading = false;
    },

    UPDATE_STARTED(state) {
      state.saveLoading = true;
    },
    UPDATE_SUCCESS(state) {
      state.saveLoading = false;
    },
    UPDATE_ERROR(state) {
      state.saveLoading = false;
    },
  },

  actions: {
    doNew({ commit }) {
      commit('RESET');
    },

    async doFind({ commit }, id) {
      try {
        commit('FIND_STARTED');
        const record = await ProductService.find(id);
        commit('FIND_SUCCESS', record);
      } catch (error) {
        Errors.handle(error);
        commit('FIND_ERROR');
        router.push('/products');
      }
    },

    async doAccept({ commit, dispatch, rootGetters }, { productId, operationType, route = false }) {
      try {
        commit('UPDATE_STARTED');
        await ProductService.accept(productId, operationType);
        commit('UPDATE_SUCCESS');

        switch (operationType) {
          case 'add':
            Message.success(i18n('product.accept.add-success'))
            break;
          case 'update':
            Message.success(i18n('product.accept.update-success'))
            break;
          default:
            Message.success(i18n('product.accept.add-success'))
            break;
        }

        if (route) {
          router.push('/products');
        } else {
          dispatch(`product/list/doFetch`, {
            filter: rootGetters[`product/list/filter`], 
            pagination: rootGetters[`product/list/pagination`]
          }, { root: true })
        }
      } catch (error) {
        Errors.handle(error);
        commit('UPDATE_ERROR');
      }
    },

    async doReject({ commit, dispatch, rootGetters }, { productId, operationType, route = false }) {
      try {
        commit('UPDATE_STARTED');
        await ProductService.reject(productId, operationType);
        commit('UPDATE_SUCCESS');

        switch (operationType) {
          case 'add':
            Message.success(i18n('product.reject.add-success'))
            break;
          case 'update':
            Message.success(i18n('product.reject.update-success'))
            break;
          default:
            Message.success(i18n('product.reject.add-success'))
            break;
        }

        if (route) {
          router.push('/products');
        } else {
          dispatch(`product/list/doFetch`, {
            filter: rootGetters[`product/list/filter`], 
            pagination: rootGetters[`product/list/pagination`]
          }, { root: true })
        }
      } catch (error) {
        Errors.handle(error);
        commit('UPDATE_ERROR');
      }
    },
  },
};
